import React from 'react';
import Icon from '../../../components/AppIcon';

const DashboardStats = ({ stats }) => {
  const statCards = [
    {
      id: 'total-projects',
      label: 'Proyectos Totales',
      value: stats?.totalProjects,
      icon: 'FolderTree',
      color: 'var(--color-primary)',
      bgColor: 'var(--color-primary)15'
    },
    {
      id: 'active-projects',
      label: 'Proyectos Activos',
      value: stats?.activeProjects,
      icon: 'Activity',
      color: 'var(--color-success)',
      bgColor: 'var(--color-success)15'
    },
    {
      id: 'total-tco2e',
      label: 'tCO₂e Total/año',
      value: stats?.totalTco2e?.toLocaleString('es-ES'),
      icon: 'Leaf',
      color: 'var(--color-accent)',
      bgColor: 'var(--color-accent)15'
    },
    {
      id: 'active-agents',
      label: 'Agentes Activos',
      value: stats?.activeAgents,
      icon: 'Users',
      color: 'var(--color-warning)',
      bgColor: 'var(--color-warning)15'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
      {statCards?.map((stat) => (
        <div key={stat?.id} className="card">
          <div className="flex items-center justify-between">
            <div className="flex-1 min-w-0">
              <p className="text-sm text-muted-foreground caption mb-1">{stat?.label}</p>
              <p className="text-2xl md:text-3xl font-semibold data-text text-foreground">
                {stat?.value}
              </p>
            </div>
            <div
              className="flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-lg flex-shrink-0"
              style={{ backgroundColor: stat?.bgColor }}
            >
              <Icon name={stat?.icon} size={24} color={stat?.color} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardStats;